/**
 * Round 80 — A-C-12 Governance & Explainability
 *
 * Allowed / forbidden phrasing for any explanation summary string.
 * Production builds: `assertSafeLanguage` is a no-op.
 * Dev builds: emits a console warning so we catch regressions.
 *
 * The lists are intentionally narrow — they cover the failure modes
 * that would change the meaning of an observational surface ("best",
 * "guaranteed", "will improve", "recommended action"). Neutral
 * descriptive language stays unrestricted.
 */
export const ALLOWED_PHRASES = [
  'Based on',
  'Observed change',
  'Associated with',
  'Confidence level',
  'Across',
  'Consistently',
  'Appears to',
] as const;

export const FORBIDDEN_PHRASES = [
  'best',
  'guaranteed',
  'will improve',
  'recommended action',
] as const;

/**
 * Dev-only guard. Logs a warning when a forbidden phrase appears in
 * an explanation summary. Never throws — never blocks rendering.
 */
export function assertSafeLanguage(summary: string, surface?: string): void {
  if (!import.meta.env.DEV) return;
  const lower = summary.toLowerCase();
  for (const bad of FORBIDDEN_PHRASES) {
    if (lower.includes(bad)) {
       
      console.warn(
        `[intelligence-explanations] Forbidden phrase "${bad}" in ${surface ?? 'explanation'}: "${summary}"`,
      );
    }
  }
}
